import config from 'config'
import Cookies from 'js-cookie'

// We've started a pricing experiment on 2019-10-10 where customers who see the website
// for the first time after this date will see the new pricing, and customers before this
// will see the old pricing. This means we need to pass the corrosponding billing version
// into the signup so that the correct plans are configured
export function getPricingVersions({ provider = 'stripe' } = {}) {
  if (provider === 'shopify') {
    return {
      preferred_inbox_billing_version: 'v7',
      preferred_kb_billing_version: 'v5',
    }
  }
  const grooveNavigation = Cookies.get('grooveNavigation', {
    domain: `.${config.appDomain}`,
  })
  const parts = (grooveNavigation || '').split(':')
  const webFirstVisit = parts[6]
  const date = webFirstVisit ? new Date(webFirstVisit) : new Date()
  // FIXME: v9 start date TBD
  const v9StartDate = new Date('2022/02/10')
  if (date.getTime() < v9StartDate.getTime()) {
    return {
      preferred_inbox_billing_version: 'v8',
      preferred_kb_billing_version: 'v4',
    }
  }
  return {
    preferred_inbox_billing_version: 'v7',
    preferred_kb_billing_version: 'v5',
  }
}

const getTrackingCampaign = () => {
  return Cookies.get('attr_cID', { domain: `.${config.appDomain}` })
}

const getTrackingGroup = () => {
  return Cookies.get('attr_gID', { domain: `.${config.appDomain}` })
}

const getTrackingKeyword = () => {
  return Cookies.get('attr_kID', { domain: `.${config.appDomain}` })
}

const getTrackingUtmz = () => {
  return Cookies.get('__utmzz', { domain: `.${config.appDomain}` })
}

const getTrackingUtmzReplica = () => {
  return Cookies.get('att_utmzz_repl', { domain: `.${config.appDomain}` })
}

export const getMarketingAttribution = () => {
  const value = Cookies.get('grooveNavigation', {
    domain: `.${config.appDomain}`,
  })

  const attrs = {}

  if (value) {
    const data = value.split(':')
    const fields = [
      'blog_first_page_url',
      'blog_first_page_date',
      'blog_last_page_url',
      'blog_last_page_date',
      'blog_articles',
      'website_first_page_url',
      'website_first_page_date',
      'website_last_page_url',
      'website_last_page_date',
      'signup_segment',
      'entrance_segment',
    ]

    fields.forEach((field, index) => {
      if (data[index] !== 'null') attrs[field] = data[index]
    })
  }

  const campaign = getTrackingCampaign()
  const group = getTrackingGroup()
  const keyword = getTrackingKeyword()
  const utmz = getTrackingUtmz()
  const utmzReplica = getTrackingUtmzReplica()

  if (campaign) attrs.campaign = campaign
  if (group) attrs.group_id = group
  if (keyword) attrs.keyword = keyword
  if (utmz) attrs.utmz = utmz
  if (utmzReplica) attrs.utmz_replica = utmzReplica

  return attrs
}

export const canShowError = (focusedFields, name, value) => {
  return !focusedFields[name] && !!value
}
